import {ChangeDetectorRef, Component, inject, Input, ChangeDetectionStrategy} from '@angular/core';
import {ImageUploadComponent} from "../image-upload/image-upload.component";
import {Organisation, OrganisationControllerService} from "../../../api";
import {Observable} from "rxjs";
import {ImageCropperComponent} from "../image-upload/image-cropper/image-cropper.component";
import {ViewImageComponent} from "../image-upload/view-image/view-image.component";
import {MatDialog} from "@angular/material/dialog";
import {faBuilding} from "@fortawesome/pro-solid-svg-icons";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

@Component({
  selector: 'app-organisation-image-upload',
    templateUrl: './organisation-image-upload.component.html',
    styleUrls: ['../image-upload/image-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FaIconComponent],
})
export class OrganisationImageUploadComponent extends ImageUploadComponent{
  private organisationControllerService = inject(OrganisationControllerService);
  private dialog = inject(MatDialog);
  private cdr = inject(ChangeDetectorRef);



  @Input() organisation!: Organisation;

  protected readonly faBuilding = faBuilding;

  ngOnInit(): void {
  }

  uploadImage(event: any) {
    const files = event.target.files as FileList;
    if (files.length > 0) {
      let filename = files[0].name;
      let fileType = files[0].type;
      const _file = URL.createObjectURL(files[0]);
      this.resetInput();
      this.openAvatarEditor(_file)
        .subscribe(
          async (result) => {
            if(result){
              let croppedFile = await this.urlToFile(result, filename, fileType);
              this.organisationControllerService.uploadImage1Form(croppedFile, this.organisation.id!)
                .subscribe(
                  (data) => {
                    super.setImage(data.profileImage);
                    this.cdr.detectChanges();
                  })
            }
          }
        )
    }
  }


  async urlToFile(url: string, filename: string, mimeType: string): Promise<File> {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], filename, { type: mimeType });
  }

  resetInput(){
    const input = document.getElementById('imageInput') as HTMLInputElement;
    if(input){
      input.value = "";
    }
  }

  openAvatarEditor(image: string): Observable<any> {
    const dialogRef = this.dialog.open(ImageCropperComponent, {
      panelClass: 'rounded-corners-dialog',
      data: image,
    });

    return dialogRef.afterClosed();
  }

  openImageOptions(image: string | undefined){
    let dialogRef = this.dialog.open(ViewImageComponent, {
      panelClass: 'rounded-corners-dialog',
      width: '750px',
      data: {image: image},
    });

    dialogRef.afterClosed().subscribe((result) => {
      if(result === 'remove'){
        this.organisationControllerService.removeImage2(this.organisation.id!).subscribe( () => {
          super.setImage(undefined);
          this.cdr.detectChanges();
        })
      }else if(result === 'upload'){
        super.triggerClickOnInput()
      }
    });

  }

}
